import { Show } from "../pages/Listings/ListingPage";

export function createHalfHourIntervals(date: Date): Date[] {
  const time = new Date(date.toDateString());

  const intervals = [];

  for (let i = 0; i < 48; i++) {
    intervals.push(new Date(time.valueOf()));
    time.setMinutes(time.getMinutes() + 30);
  }

  return intervals;
}

export function roundTime(time: Date): Date {
  const nownow = new Date(
    `${time.toLocaleDateString()} ${time.getHours()}: ${
      time.getMinutes() < 30 ? "00" : "30"
    }`
  );

  return nownow;
}

export function roundShowTimes(shows: Show[]) {
  return shows.map(show => ({
    ...show,
    time: {
      start: roundTime(new Date(show.time.start))
    }
  }));
}
